import homeWhiteSvg from 'assets/images/home-white.svg';

export enum Phases {
  PRE_APPROVAL = 'pre-approval',
  APPROVAL = 'approval',
  DUE_DILIGENCE = 'due-diligence',
  FINAL = 'final',
  CLOSING = 'closing',
}

export const PhasesLabel: any = {
  'pre-approval': 'PRE APPROVAL',
  'approval': 'APPROVAL',
  'due-diligence': 'DUE DILIGENCE',
  'final': 'FINAL',
  'closing': 'CLOSING'
}

export interface LoanPhases {
  id: number;
  name: string;
  description?: string;
  key: string;
  state?: string;
  stateName?: string;
  text: string;
  tasksItems: any[];
  lenderTasks?: any[];
}

export const LOAN_PHASES: LoanPhases[] = [
  {
    id: 1,
    name: 'Pre-Approval',
    key: Phases.PRE_APPROVAL,
    text: 'Answer a few questions to get pre-approved for a loan',
    description: 'Your basic information and loan request are reviewed so you can quickly see your loan terms and options.',
    tasksItems: [
      {
        id: 1,
        key: 'initial_app',
        text: 'Initial application',
        state: 'APPROVED'
      }
    ],
    lenderTasks: [
      {
        id: 1,
        key: 'pre_approval_letter',
        text: 'Pre-approval letter',
        titleButton: 'View',
        state: 'APPROVED'
      },
      {
        id: 2,
        key: 'term_sheet',
        text: 'Term sheet generated',
        titleButton: 'View',
        state: 'APPROVED'
      }
    ]
  },
  {
    id: 2,
    name: 'Approval Docs & Term Sheet',
    key: Phases.APPROVAL,
    text: 'Submit a full application including required docs, which we’ll review',
    description: 'Submit key documents and get the tasks that takes the longest going, eg. Appraisal and Title',
    tasksItems: [],
    lenderTasks: [
      {
        id: 1,
        key: 'appraisal_ordered',
        text: 'Appraisal ordered',
      },
      {
        id: 2,
        key: 'title_requested',
        text: 'Title requested',
      },
      {
        id: 3,
        key: 'credit_check',
        text: 'Credit report ran',
      },
      {
        id: 4,
        key: 'background_check',
        text: 'Background check verified',
      },
    ]
  },
  {
    id: 3,
    name: 'Property Evaluation & Due Diligence',
    key: Phases.DUE_DILIGENCE,
    text: 'Submit any remaining docs, while we conduct due diligence to verify your info',
    description: 'We verify property details, order necessary reports, and get all borrower docs submitted to underwriting.',
    tasksItems: [],
    lenderTasks: [
      {
        id: 1,
        key: 'appraisal_approved',
        text: 'Appraisal approved',
      },
      {
        id: 2,
        key: 'insurance_verified',
        text: 'Insurance approved',
      },
      {
        id: 3,
        key: 'track_record_verified',
        text: 'Track record verified',
      }
    ]
  },
  {
    id: 4,
    name: 'Final Approval',
    key: Phases.FINAL,
    text: 'After any last minute items are complete, your loan is approved and you get your loan agreement',
    description: 'Your loan gets final approval so your loan can be prepared for closing.',
    tasksItems: [],
    lenderTasks: [
      {
        id: 1,
        key: 'title_cleared',
        text: 'Title cleared to close',
      },
      {
        id: 2,
        key: 'lender_cleared_to_close',
        text: 'Lender cleared to close'
      }
    ]
  },
  {
    id: 5,
    name: 'Closing',
    key: Phases.CLOSING,
    text: 'Loan agreement signed, we deposit your funds in your account within X days',
    description: 'Loan documents are signed, funds are released, and your loan is officially complete.',
    tasksItems: [],
    lenderTasks: [
      {
        id: 1,
        key: 'closing_docs',
        text: 'Final closing items',
        titleButton: 'View closing docs',
        state: 'DRAFT'
      }
    ]
  }
];
